/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Dec 06 2024
 **/

import { HTMLAttributes, PropsWithChildren } from "react";
import Draggable from "react-draggable";

import useWhiteboardStore from "../stores/useWhiteboardStore";
import { DrawingContainerStyle } from "./emotion";
import Presets from "../presets";
import useDraggable from "@/hooks/useDraggable";

interface DrawingProps extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
	whiteboardMode: WhiteboardMode;
}

export default function Drawing({ whiteboardMode, children, ...props }: DrawingProps) {
	const windowState = useWhiteboardStore((state) => state.windowState);
	const { draggableOptions, nodeRef } = useDraggable();

	return (
		<Draggable {...draggableOptions} nodeRef={nodeRef}>
			<div
				ref={nodeRef}
				css={DrawingContainerStyle}
				id={Presets.containerId}
				className={`drawing ${windowState} ${whiteboardMode}`}
				{...props}
			>
				{children}
			</div>
		</Draggable>
	);
}
